"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _common = require("../@api/common");
var _store = require("../@api/store");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/// GROUP CHAT based on appcenter groups

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    defaultTab = _ref.defaultTab,
    onTabChange = _ref.onTabChange;
  var _useState = (0, _react.useState)(defaultTab),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  (0, _react.useEffect)(function () {
    if (typeof onTabChange === 'function') onTabChange(current);
  }, [current]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "zero-tabs"
  }, tabs.map(function (tab, i) {
    if (tab.hidden) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab ".concat(tab.id === current ? 'active' : ''),
      key: tab.id,
      onClick: function onClick(e) {
        return setCurrent(tab.id);
      }
    }, !!tab.icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: tab.icon
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, tab.name));
  }));
};
Tabs.Content = function (_ref2) {
  var tab = _ref2.tab,
    currentTab = _ref2.currentTab,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "zero-tabs-content ".concat(tab === currentTab ? 'active' : '')
  }, children);
};
var _default = Tabs;
exports["default"] = _default;